import React from 'react';
import Avatar from '@material-ui/core/Avatar';
import { avatarUrl } from '../../utility/avatar';

// Circular user avatar used across the app. Shows the uploaded picture when there is one and
// the first letter of the name otherwise (MUI also falls back to the letter if the image fails).
const UserAvatar = ({ avatar, name, size = 35, style, className, ...rest }) => {
  const src = avatarUrl(avatar, size);
  const initial = (name || "").charAt(0).toUpperCase();
  return (
    <Avatar
      className={className}
      src={src || undefined}
      alt={name}
      style={{ width: size, height: size, ...style }}
      {...rest}
    >
      {initial}
    </Avatar>
  );
};

export default UserAvatar;
